import React from 'react';
import { i18n } from 'utils/i18n';
import { getImageFromImagesObject } from 'utils/vehicles';
import { announceAssistiveStatus } from 'utils/accessibility/assistiveStatusAnnouncer';
import cn from 'classnames';
import Picture from 'components/Picture';
import Button from 'components/Button';
import { propTypes } from './bundlesPropTypes';
import BundlesCard from './BundlesCard';

const Bundles = ({
  bundles,
  includedBundlesExtras,
  showBundlesDetailsModal,
  displayCarClass,
  scrollToRef,
  hasClearAbove,
  vehicleImages,
  makeModelOrSimilarText,
  additionalDriversPolicy,
  selectCarClass,
  code,
  isPayLater,
}) => {
  const handleClickBundle = (bundle_code, isSelected) => {
    // Updates live region text for screen readers when adding or removing a bundle
    announceAssistiveStatus(i18n('wcag_loading'));
    selectCarClass({
      code,
      bundle_code: !isSelected ? bundle_code : bundles.find((item) => item.default_bundle).name,
      prepay: !isPayLater,
      redirect: false,
    }).then(() => {
      const bundleTitle = bundles.find((item) => item.name === bundle_code).title;
      // Announce the action performed (added or removed) along with the bundle title for screen readers
      announceAssistiveStatus(`${isSelected ? i18n('wcag_removed') : i18n('extras_added')} ${bundleTitle}`);
    });
  };

  const carImage = getImageFromImagesObject(vehicleImages);

  return (
    <>
      <div className={cn('bundles__container', { 'bundles__container--clear-above': hasClearAbove })}>
        {displayCarClass && (
          <div className='bundles__vehicle-img-container'>
            <img className='bundles__vehicle-img--background' />
            <Picture
              className='bundles__vehicle-img'
              alt={makeModelOrSimilarText}
              src={carImage}
              srcMobile={carImage}
              srcTablet={carImage}
            />
          </div>
        )}
        <div className='bundles__header'>
          <h2>{i18n('bundles_section_header')}</h2>
          <p>
            {i18n('bundles_section_description')}&nbsp;
            <Button
              onClick={scrollToRef}
              link
              className='link--text normal-font'
              ariaText={i18n('bundles_section_description_link')}
            >
              {i18n('bundles_section_description_link')}
            </Button>
          </p>
        </div>
        {bundles && (
          <div className='bundles__cards-wrapper'>
            {bundles.map(
              (bundle) =>
                !bundle?.default_bundle && (
                  <BundlesCard
                    key={bundle.name}
                    isSelected={bundle.selected}
                    onClickBundle={handleClickBundle}
                    showBundlesDetailsModal={showBundlesDetailsModal}
                    includedBundlesExtras={includedBundlesExtras}
                    additionalDriversPolicy={additionalDriversPolicy}
                    {...bundle}
                  />
                )
            )}
          </div>
        )}
      </div>
    </>
  );
};

Bundles.propTypes = propTypes;

export default Bundles;
